import { useMemo } from 'react';
import { useSetting } from './useSetting';

export default function useCalendar() {
  const { setting } = useSetting();
  const isJalali = useMemo(() => {
    if (!setting || typeof setting.calendar === 'undefined') return null;
    return setting.calendar === 'Jalali';
  }, [setting?.calendar]);
  return isJalali;
}